import React from 'react';
import styled from 'styled-components';
import { GiCompass } from 'react-icons/gi';
import { ScreenSizes } from 'components/shared';
import { Text } from 'components/shared';

// Same layout/style as RPM.js (icon + value + unit label) - shown alongside
// it for turbine types whose pitch drive publishes a live position
// (dbname "pitch_1", category "revolution" - see Orbital-server's
// turbineSchemas/xlsx/ntk300.xlsx). undefined/null value (no such register
// on this turbine type) renders nothing at all, not a "0°" that would look
// like a real reading.
const Wrapper = styled.div`
  display: flex;
  align-items: center;

  ${ScreenSizes.lessThan('tablet')`
  padding: 0 0.5rem 0 0;
  `}
`;

const Value = styled(props => <Text {...props} />)`
  color: ${props => props.theme.textDark};
  font-weight: 400;
`;

const UnitText = styled(Value)`
  color: ${props => props.theme.textMedium};
  font-weight: 300;
`;

const Pitch = ({ value, hideLabel = false }) => {
  if (value === undefined || value === null) return null;

  if (typeof value === 'number' && !Number.isInteger(value)) {
    value = value.toFixed(1);
  }

  return (
    <Wrapper>
      <GiCompass color="grey" size="1.2em" />
      <Value size={18}>{value}°</Value>
      {!hideLabel && <UnitText size={14}>Pitch</UnitText>}
    </Wrapper>
  );
};

Pitch.propTypes = {};

Pitch.defaultProps = {};

export default Pitch;
